import { MutableState } from 'src/replicant/State';
import { getMatch2WinLadderResetTimestampKey } from '../match2.ruleset';
import { getMatch2Timestamp } from '../match2.getters';
import { clamp } from 'src/replicant/utils';
import { setMatch2Timestamp } from '../match2.modifiers';
import { duration } from 'src/replicant/utils/duration';
import * as Inventory from 'src/replicant/inventory';

/**
 * Reset the win ladder if it's over its 24 hour reset timer
 */
export function resetRubberbandingLadderStep(
  state: MutableState,
  now: number,
): void {
  const key = getMatch2WinLadderResetTimestampKey();
  let lastUpdatedAt = getMatch2Timestamp(state, key);
  const remaining = Math.max(lastUpdatedAt - now, 0);
  if (remaining === 0) state.match2.winLadderStep = 1;
}

/**
 * Increment/decrement the win ladder based on the result of the match
 */
export function updateRubberbandingLadderStep(
  state: MutableState,
  now: number,
  won: boolean,
  hasContinued: boolean,
): void {
  const over2000gems = Inventory.getters.getGems(state) > 2000;

  if (won) {
    // Otherwise, use the existing logic
    if (!hasContinued) state.match2.winLadderStep += over2000gems ? 2 : 1;
    else if (over2000gems) state.match2.winLadderStep++;
  }
  // Step down every lost if under 2000 gems, or every other lost if over 2000 gems
  else if (
    !over2000gems ||
    (state.match2.losingStreak > 0 && state.match2.losingStreak % 2 === 0)
  ) {
    state.match2.winLadderStep--;
  }

  // Clamping the rubberbanding ladder step between -10 and 10
  state.match2.winLadderStep = clamp(state.match2.winLadderStep, -10, 10);

  // Refresh the win ladder reset timestamp
  setMatch2Timestamp(
    state,
    getMatch2WinLadderResetTimestampKey(),
    now + duration({ hours: 48 }),
  );
}
